import { isNullOrUndefined } from "../../../services/Validator";
import CoursesSubthemesContent from "./CoursesSubthemesContent";
import {
    GradePickerSize
} from "../../../controllers/flashScreens/parameterStepScreen/ParameterGradeBadgeItemController";
import CoursesGradesList from "../../lists/courses/CoursesGradesList";
import SystemAppContentLoader from "../../loaders/SystemAppContentLoader";
import SystemAppContentError from "../../errors/SystemAppContentError";

export default function CoursesCoreContent({ isGradesLoading,
                                             grades,
                                             gradesError,
                                             flashError,
                                             getFlashGrades,
                                             exerciserError,
                                             selectedGrade,
                                             setFlashGrade,
                                             isSubthemesLoading,
                                             subthemesError,
                                             subthemes,
                                             selectSubtheme,
                                             selectedSubtheme,
                                             levelAs,
                                             selectedLevelAs,
                                             pickLevelA,
                                             clearLevelAs,
                                             // ---- Flash
                                             isFlashLoading,
                                             fetchFlashQuestions,
                                             // ---- Exerciser
                                             isExerciserLoading,
                                             fetchExerciserProblem }) {
    // Used in CoursesScreen to display both
    // Grade and Subthemes pickers

    // BUILD
    if (!isNullOrUndefined(gradesError))
        return <SystemAppContentError error={gradesError}
                                      isLoading={isGradesLoading}
                                      retryCallback={() => getFlashGrades()} />
    if (!isNullOrUndefined(flashError))
        return <SystemAppContentError error={flashError}
                                      isLoading={isFlashLoading}
                                      retryCallback={() => fetchFlashQuestions()} />
    if (!isNullOrUndefined(exerciserError))
        return <SystemAppContentError error={exerciserError}
                                      isLoading={isExerciserLoading}
                                      retryCallback={() => fetchExerciserProblem()} />
    if (isGradesLoading)
        return <SystemAppContentLoader />
    return (
        <div className={"w-full grow h-[560px] min-h-[520px] max-h-[640px] flex flex-col"}>
            <CoursesGradesList grades={grades}
                               selectedGrade={selectedGrade}
                               setFlashGrade={setFlashGrade}
                               gradePickerSize={GradePickerSize.MEDIUM}
                               extraClass={"mt-[24px]"} />
            <CoursesSubthemesContent selectedGrade={selectedGrade}
                                     isSubthemesLoading={isSubthemesLoading}
                                     subthemesError={subthemesError}
                                     subthemes={subthemes}
                                     selectSubtheme={selectSubtheme}
                                     selectedSubtheme={selectedSubtheme}
                                     levelAs={levelAs}
                                     pickLevelA={pickLevelA}
                                     clearLevelAs={clearLevelAs}
                                     selectedLevelAs={selectedLevelAs}
                                     // ---- Flash
                                     fetchFlashQuestions={fetchFlashQuestions}
                                     isFlashLoading={isFlashLoading}
                                     // ---- Exerciser
                                     isExerciserLoading={isExerciserLoading}
                                     fetchExerciserProblem={fetchExerciserProblem} />
        </div>
    );
}